/******************
// directive: animatedService
*************/
angular.module('app')
        .controller('animatedServicesCtrl', animatedServicesCtrl)
        .directive('animatedServices', animatedServices);

animatedServicesCtrl.$inject = ['$scope'];
function animatedServicesCtrl($scope) {
    const ctrl = this;
    ctrl.scrollableContents = null;
    ctrl.contentIndex = 0;
    ctrl.totalSection = 2;
    ctrl.container = null;
    ctrl.slideInfo = null;
    ctrl.activeServiceIndex = -1;
    const isMobile = false;

    ctrl.resetNav = function () {
        $scope.$broadcast('resetServiceNav', { currentSection: ctrl.slideInfo.currentIndex });
    }

    ctrl.setNav = function () {
        $scope.$broadcast('setServiceNav', { currentSection: ctrl.slideInfo.currentIndex });
    }

    ctrl.tweenService = new TimelineMax();
    ctrl.tweenServiceOut = new TimelineMax();
    ctrl.scrollSection = function () {

        if (ctrl.slideInfo.currentIndex == 1) {
            restartFirstSlide();
        }
        else {
            ctrl.animateSlide2();
        }
        ctrl.setNav();
    }

    function restartFirstSlide() {
        //reset everything for tweenServiceOut
        if (ctrl.tweenServiceOut.progress() === 0) {
            ctrl.tweenServiceOut.pause();
        }

        ctrl.tweenServiceOut.restart().pause();
        ctrl.tweenServiceOut = new TimelineMax();

        //reset everything for tweenService
        if (ctrl.tweenService.progress() === 0) {
            ctrl.tweenServiceOut.pause();
        }
        ctrl.tweenService.restart().pause();
        ctrl.tweenService = new TimelineMax();
        ctrl.animateSlide1();
    }

    // animation variables        
    //let scrollArrowTween = null;
    ctrl.animateSlide1 = function () {
        const services = ctrl.container.find('.services > ul > li');
        const introText = ctrl.container.find('.set1-intro-text');
        const xLargeText = ctrl.container.find('.set1-xlarge-text');
        const imageContainer = ctrl.container.find('.image-container');
        const imageContainerLine = ctrl.container.find('.image-container-line');
        const mobileIntroText = ctrl.container.find('.mobile-set1-intro-text');
        const circleBorder = imageContainer.find('#circle-border');
        const blockWhites = services.find('.service-boxed .block-white');

        if (!ctrl.isMobile) {
            ctrl.tweenService
                .set(introText, { opacity: 0, display: 'none' })
                .set(imageContainerLine, { width: 0, right: '-99px', left: 'auto' })
                .set(circleBorder, {drawSVG: '0% 0%', transformOrigin:'50% 50%', rotationX:'180'})
                .set(ctrl.scrollArrow, { opacity: 0, display: 'none' })
                .set(blockWhites[0], { width: 0 })
                .to(xLargeText, 0.75, { x: 0, startAt: { x: +350 }, opacity: 1, display: 'block', ease: Power2.easeInOut })
                .to(imageContainer, 0.5, { y: 0, startAt: { y: -(ctrl.container.height() / 2 - 200) }, opacity: 1, ease: Power2.easeInOut }, '-=0.25')
                .set(imageContainerLine, { opacity: 0, width: 0 }, '-=0.25')
                .to(imageContainerLine, 0.25, { width: '99px', opacity: 1, ease: Power1.easeInOut }, '-=0.25')
                .to(circleBorder, 0.25, { drawSVG: '0% 100%', ease: SlowMo.easeInOut })
                //.to(imageContainer, 0.5, { borderWidth: 1, ease: Power0.easeInOut })
                .staggerTo(services, 0.2, { opacity: 1, y: 0, startAt: { y: +100 }, ease: Back.easeIn }, -0.05, '-=0.5')
                .to(introText, 0.5, { x: 0, startAt: { x: -50 }, opacity: 1, display: 'block', ease: Power2.easeInOut, onComplete: tweenOnComplete }, '-=0.5')
        }
        else { //mobile animation
            ctrl.tweenService = mobileAnimationSlide1()
        }
    }


    //-----------------------------------------------------
    ctrl.animateSlide2 = function () {
        const xLargeText = ctrl.container.find('.set1-xlarge-text');
        const imageContainer = ctrl.container.find('.image-container');
        const circleBorder = imageContainer.find('#circle-border');
        const imageContainerLine = ctrl.container.find('.image-container-line');
        const servicesUL = ctrl.container.find('.services > ul');
        const services = servicesUL.find('> li');
        const servicesBorderRightSide = services.find('.service-boxed .right-side');
        const servicesBorderBottomSide = services.find('.service-boxed .bottom-side');
        const servicesBorderTopSide = services.find('.service-boxed .top-side');
        const servicesBorderLeftSide = services.find('.service-boxed .left-side');
        const close = services.find('.service-boxed a .close');
        const blockWhites = services.find('.service-boxed .block-white');
        const introText = ctrl.container.find('.set1-intro-text');
        const circleWhite = ctrl.container.find('#animatedServiceCircleWhite');
        const starbursts = ctrl.container.find('.starbursts');

        const logoSlogan = ctrl.container.find('.logo-slogan');
        const set2XlargeText = ctrl.container.find('.set2-xlarge-text');
        const circularTexts = ctrl.container.find('.circular-texts');
        const set2IntroText = ctrl.container.find('.set2-intro-text');

        if (!ctrl.isMobile) {
            ctrl.tweenServiceOut
                .set(ctrl.scrollArrow, { opacity: 0, display: 'none' })
                .to(introText, 0.5, { y: -100, opacity: 0, display: 'none', ease: Power2.easeInOut })
                .to(xLargeText, 0.5, { x: +50, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.5')
                .set(circularTexts, { display: 'block' })
                .to(imageContainerLine, 0.25, { startAt: { right: 'auto', left: '100%' }, width: 0, opacity: 0, ease: Power1.easeInOut }, '-=0.5')
                //.to(imageContainer, 0.5, { borderWidth: 0, ease: SlowMo.easeInOut })
                .to(circleBorder, 0.25, { drawSVG: '0% 0%' }, '-=0.4')
                .staggerTo(servicesBorderRightSide, 0.1, { opacity: 0, ease: Back.easeIn }, -0.02, '-=1.25')
                .staggerTo(close, 0.1, { opacity: 0, ease: Back.easeIn }, -0.05, '-=0.5')
                .staggerTo(servicesBorderBottomSide, 0.1, { width: 0, ease: Power2.easeInOut }, -0.02, '-=0.3')
                .staggerTo(servicesBorderTopSide, 0.1, { width: 0, ease: Power2.easeInOut }, -0.02, '-=0.4')
                .staggerTo(servicesBorderLeftSide, 0.1, { height: 0, ease: Power2.easeInOut }, -0.02, '-=0.3')
                .staggerTo(blockWhites, 0.1, { width: '100%', ease: Power2.easeInOut }, 0.03, '-=0.25')
                .to(blockWhites[0], 0.1, { startAt: { x: -5, right: 'auto' }, x: -60, width: '50%', ease: Power2.easeInOut }, '-=0.1')
                .add(createBlockWhiteTween(blockWhites))
                .to('.services ul > li a', 0.1, { opacity: 0 })
                .add(mergeBlockWhiteTween(blockWhites))
                .to(blockWhites[0], 0.1, { x: -150, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.25')
                .set(ctrl.container.find('.services'), { display: 'none' })
                .to(circleWhite, 0.1, { opacity: 1, ease: Power2.easeInOut }, '-=0.1')
                .to(circleWhite, 0.5, { rotation: -360, scale: 0.75, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.25')

                //.to(logoSlogan, 1, { startAt: { scale: 0 }, scale: 1, opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=0.5')
                .to(logoSlogan, 0.3, { rotation: -10, opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=0.25')
                //.to(logoSlogan, 3, { rotation: -180, ease: SlowMo.easeInOut }, '-=0.25')
                .add(logoSloganRotateTween(logoSlogan), '-=0.25')
                .to(starbursts, 0.25, { opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=1.25')
                .to(starbursts, 0.25, { scale: 1.2, ease: Power2.easeInOut }, '-=1.1')
                .to(starbursts, 0.25, { scale: 1, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.75')
                .to(set2XlargeText, 0.5, { x: 0, startAt: { x: +350 }, opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=1.25')
                .to(circularTexts, 0.75, { y: 0, startAt: { y: +500 }, opacity: 1, ease: Bounce.easeOut }, '-=0.75')
                .to(set2IntroText, 0.5, { x: 0, startAt: { x: -100 }, opacity: 1, display: 'block', ease: Power4.easeInOut, onComplete: tweenOnComplete }, '-=0.75')
        }
        else {
            ctrl.tweenServiceOut.add(mobileAnimationSlide2())
        }
    }

    function createBlockWhiteTween(blockWhites) {
        const blockWhitesTL = new TimelineMax();
        for (var indx = blockWhites.length - 1; indx >= 1; indx--) {
            var pos = (((blockWhites.length - 1) - indx) * 15) - 45;
            blockWhitesTL.to(blockWhites[indx], 0.1, { startAt: { x: -5, right: 'auto' }, x: pos, width: '30%', ease: Power2.easeInOut }, "-=1");
        }
        return blockWhitesTL;
    }

    function mergeBlockWhiteTween(blockWhites) {
        const topPost = blockWhites[0].offsetTop;
        const blockWhitesTL = new TimelineMax();
        for (var indx = 1; indx <= blockWhites.length - 1; indx++) {
            var top = ($(blockWhites[indx]).parent().height() * indx) + topPost;
            blockWhitesTL.to(blockWhites[indx], 0.1, { y: -(top), opacity: 0, display: 'none', ease: Power2.easeInOut }, "-=0.1");
        }
        return blockWhitesTL;
    }

    function logoSloganRotateTween(logoSlogan) {
        const tweenLogo = new TimelineMax();
        for (var x = 1; x <= 3; x++) {
            tweenLogo.to(logoSlogan, 0.5, { rotation: -((x * 15) + 20), ease: Elastic.easeNone });
        }
        return tweenLogo;
    }

    function tweenOnComplete() {
        if (parseInt(ctrl.contentIndex) === parseInt(ctrl.scrollableContents.totalSections)) {
            ctrl.scrollableContents.setArrowVisibility(false);
            ctrl.scrollableContents.setFooterVisibility(true);
        }
        else {
            ctrl.scrollableContents.setArrowVisibility(true);
        }
    }
    
    //------------------------------
    //mobile animation 
    function mobileAnimationSlide1() {
        const xLargeText = ctrl.container.find('.set1-xlarge-text');
        const logoContainer = ctrl.container.find('.logo-container');
        const imageContainer = ctrl.container.find('.image-container');
        const imageContainerLine = ctrl.container.find('.image-container-line');
        const circleContainer = imageContainer.find('.circle-container');
        const services = ctrl.container.find('.services');
        const servicesItems = ctrl.container.find('.services ul > li');
        const introText = ctrl.container.find('.set1-intro-text');
        const mobileIntroText = ctrl.container.find('.mobile-set1-intro-text');

        return new TimelineMax()
                .set(ctrl.scrollArrow, { opacity: 0, display: 'none' })
                .set(circleContainer, { opacity: 0 })
                .to(xLargeText, 1, { x: 0, startAt: { x: +350 }, opacity: 1, ease: Power2.easeInOut })
                .to(mobileIntroText, 1, { x: 0, startAt: { x: -350 }, opacity: 1, ease: Power2.easeInOut }, '-=1')
                .to(imageContainer, 1, { y: 0, startAt: { y: -(ctrl.container.height() / 2 - 200) }, opacity: 1, ease: Power2.easeInOut }, '-=0.75')
                .set(imageContainerLine, { opacity: 0, width: 0 })
                //.to(imageContainerLine, 0.5, { width: '99px', opacity: 1, ease: Power1.easeInOut })
                //.to(imageContainer, 0.5, { borderWidth: 1, ease: Power0.easeInOut }, '-=0.5')
                .to(logoContainer, 0.5, { x: -(ctrl.container.width()), startAt: { y: 0 }, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.25')
                //.to(servicesItems, 0.3, { opacity: 1, x: 0, startAt: { x: +200 }, ease: Back.easeIn }, '-=0.5')
                .staggerTo(servicesItems, 0.25, { opacity: 1, x: 0, startAt: { x: +200 }, ease: Back.easeIn, onComplete: tweenOnComplete }, 0.02, '-=0.2')
        //.to(services, 1, { x: '-38%', ease: Power2.easeInOut }, '-=1')
    }

    function mobileAnimationSlide2() {
        const xLargeText = ctrl.container.find('.set1-xlarge-text');
        const logoContainer = ctrl.container.find('.logo-container');
        const imageContainer = ctrl.container.find('.image-container');
        const circleContainer = imageContainer.find('.circle-container');
        const imageContainerLine = ctrl.container.find('.image-container-line');
        const services = ctrl.container.find('.services');
        const servicesItems = ctrl.container.find('.services ul > li');
        const mobileIntroText = ctrl.container.find('.mobile-set1-intro-text');
        const set2XlargeText = ctrl.container.find('.mobile-set2-xlarge-text');
        const circleWhite = ctrl.container.find('#animatedServiceCircleWhite');
        const starbursts = ctrl.container.find('.starbursts');
        const logoSlogan = ctrl.container.find('.logo-slogan');
        const circularTexts = ctrl.container.find('.circular-texts');
        const set2IntroText = ctrl.container.find('.mobile-set2-intro-text');

        return new TimelineMax()
            .set(ctrl.scrollArrow, { opacity: 0, display: 'none' })
            .set(logoContainer, { opacity: 0, display: 'none', y: 100 })
            .set(imageContainerLine, { opacity: 0, display: 'none' })
            //.set(imageContainer, { borderWidth: 0 })
            .set(circleContainer, { opacity: 0 })
            .to(mobileIntroText, 0.25, { x: -350, opacity: 0, display: 'none', ease: Power2.easeInOut })
            .to(xLargeText, 0.25, { x: 350, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.25')
            .to(services, 0.25, { opacity: 0, display: 'none', ease: Power4.easeInOut }, '-=0.25')
            .to(set2XlargeText, 0.25, { x: 0, startAt: { x: +350 }, opacity: 1, display: 'block', ease: Power2.easeInOut })
            .to(logoContainer, 0.5, { x: '-50%', opacity: 1, display: 'block', ease: Elastic.easeInOut }, '-=0.25')
            .to(circleWhite, 0.2, { opacity: 1, ease: Power2.easeInOut }, '-=0.3')
            .to(circleWhite, 1, { rotation: -360, scale: 0.75, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.5')

            .to(logoSlogan, 0.5, { rotation: -10, opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=0.25')
            //.add(logoSloganRotateTween(logoSlogan), '-=0.5')
            .to(logoSlogan, 0.75, { rotation: -180, ease: SlowMo.easeInOut }, '-=0.25')
            .to(starbursts, 0.25, { opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=1')
            .to(starbursts, 0.25, { scale: 1.2, ease: Power2.easeInOut }, '-=0.75')
            .to(starbursts, 0.25, { scale: 1, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.25')

            .to(logoContainer, 0.25, { scale: 0.6, opacity: 0, display: 'none', ease: Power3.easeInOut }, '-=0.25')
            .to(set2XlargeText, 0.25, { x: +100, opacity: 0, display: 'none', ease: Power3.easeInOut })
            .to(set2IntroText, 0.25, { x: 0, startAt: { x: -100 }, opacity: 1, display: 'block', ease: Power4.easeInOut })
            .to(circularTexts, 0.25, { y: 0, startAt: { y: +500 }, opacity: 1, display: 'block', ease: Power3.easeOut, onComplete: tweenOnComplete })
    }

    function mobileAnimationSet() {
        var logoContainer = ctrl.container.find('.logo-container');

        if (currentSetIndex == 1) {
            tweenService.to(logoContainer, 1, { x: '-100%', ease: Power2.easeInOut })
        }

        currentSetIndex++;
    }

    //-------------------------------------------------------

    $scope.$on('animate', function (event, args) {
        if (args.index === parseInt(ctrl.contentIndex)) {
            $scope.$broadcast('hideServiceNav', { show: true })
            restartFirstSlide();            
        }
    })

    $scope.$on('animateNextSlide', function (event, args) {
        if (args.contentIndex === parseInt(ctrl.contentIndex)) {
            ctrl.scrollableContents.hideMainNav(); //force hide main nav
            let isPlaying = true;
            if (ctrl.slideInfo.currentIndex == 1) {
                isPlaying = ctrl.tweenService.isActive();
            }
            else {
                isPlaying = ctrl.tweenServiceOut.isActive();
            }

            if (!isPlaying) {
                ctrl.scrollableContents.setArrowVisibility(false);
                const scrollDir = parseInt(args.scrollDir);
                if (scrollDir === -1) {
                    $scope.$broadcast('resetServiceNav', { currentSection: 2 });
                    restartFirstSlide();
                    $scope.$broadcast('setServiceNav', { currentSection: 1 });
                }
                else {
                    $scope.$broadcast('resetServiceNav', { currentSection: 1 });
                    ctrl.animateSlide2();
                    $scope.$broadcast('setServiceNav', { currentSection: 2 });
                }
                ctrl.slideInfo.currentIndex += scrollDir;
            }
        }
    })

    $scope.$on('resetNavigation', function (event, args) {
        $scope.$broadcast('resetServiceNav', { currentSection: parseInt(args.lastIndex) });
        $scope.$broadcast('setServiceNav', { currentSection: 1 });
    })
}

animatedServices.$inject = ['$timeout']
function animatedServices($timeout) {
    return {
        restrict: 'E',
        require: {
            scrollableContents: '^^scrollableContents',
            scrollableItem: '^^scrollableItem',
            animatedServices: 'animatedServices'
        },
        link: link,
        controller: animatedServicesCtrl
    }

    function link(scope, element, attrs, ctrl) {
        ctrl.animatedServices.scrollableContents = ctrl.scrollableContents;
        ctrl.animatedServices.isMobile = ctrl.scrollableContents.isMobile;
        ctrl.animatedServices.contentIndex = ctrl.scrollableItem.contentIndex;

        const container = angular.element(element);
        ctrl.animatedServices.container = container;
        ctrl.animatedServices.scrollArrow = container.find('.inner-scroll-arrow');

        //hide main scroll arrow
        ctrl.scrollableContents.setArrowVisibility(false);

        //tell scrollableContents controller that directive has extra slides
        ctrl.animatedServices.slideInfo = {
            contentIndex: parseInt(ctrl.scrollableItem.contentIndex),
            totalSections: 2,
            currentIndex: 1,
            started: false
        }
        ctrl.scrollableContents.includeSectionHasExtraSlides(ctrl.animatedServices.slideInfo);

        //hover service events listener
        if (!ctrl.animatedServices.isMobile) {
            const services = container.find('.services > ul > li');
            const introText = container.find('.set1-intro-text');

            services.each(function (key, serviceItem) {
                angular.element(serviceItem).on('click', function () {
                    const control = angular.element(this);
                    const subservicesCount = parseInt(control.data('subservices'));
                    const index = parseInt(control.data('index'));

                    if (subservicesCount > 0) {
                        //introText.hide();                        
                        const element = $(event.srcElement || event.target);
                        const parentLi = $(element).closest('li');
                        parentLi.addClass('active');
                        const servicesMenu = parentLi.find('.services-menu');
                        const logoContainer = container.find('.logo-container');
                        const services = container.find('.services');

                        //compute top
                        const firstServiceTop = (parentLi.height() + 24) * index;
                        const parentTop = angular.element('.services').parent().position().top;
                        servicesMenu.css({
                            top: -(firstServiceTop + parentTop),
                            width: (container.width() - (logoContainer.width() + services.width())) - 100
                        });

                        const mouseEnterTween = new TimelineMax()
                            .to(introText, 0.5, { x: +300, opacity: 0, display: 'none', ease: Power2.easeInOut });
                        if (parentLi.data('index') !== ctrl.activeServiceIndex) {
                            if (ctrl.activeServiceIndex !== -1) {
                                mouseEnterTween.add(hideActiveServiceMenu(), '-=0.5');
                            }
                            ctrl.activeServiceIndex = parentLi.data('index');
                            mouseEnterTween
                                .to(servicesMenu, 0.5, { opacity: 1, display: 'flex', x: 0, startAt: { x: -200 }, ease: Back.easeInOut }, '-=0.5');
                        }
                        
                            //.staggerTo(servicesMenu, 0.5, { opacity: 1, display: 'flex', x: 0, startAt: { x: -200 }, ease: Back.easeIn }, 0.05, '-=0.25')
                    }
                    else {
                        //introText.show();
                        new TimelineMax()
                            .to(introText, 0.5, { x: 0, opacity: 1, display: 'block', ease: Power2.easeInOut })
                            .add(hideActiveServiceMenu(), '-=0.5')

                        ctrl.activeServiceIndex = -1;
                    }
                })
            });

            //
            container.find('.services').on('mouseleave', function () {
                //introText.show();
                new TimelineMax()
                    .to(introText, 0.5, { x: 0, opacity: 1, display: 'block', ease: Power2.easeInOut })
                    .add(hideActiveServiceMenu(), '-=0.5');
                ctrl.activeServiceIndex = -1;
            });
        }

        function hideActiveServiceMenu() {
            const services = container.find('.services > ul > li');
            const activeService = angular.element(services[ctrl.activeServiceIndex]);

            if (activeService) {
                activeService.removeClass('active');
                const servicesMenu = activeService.find('.services-menu');
                if (servicesMenu) {
                    return new TimelineMax()
                        .to(servicesMenu, 0.5, { opacity: 0, display: 'none', x: -200, ease: Power3.easeInOut });
                }
            }

            return new TimelineMax();
        }

        //------------------------------------------
        //service link click
        const clicked = false;
        container.find('.services .mobile-service-btn').each(function (index, link) {
            angular.element(link)
                .on('click', function (event) {
                    event.stopPropagation();
                    const parentLi = angular.element(link).closest('li');
                    const parentUl = parentLi.closest('ul');
                    const servicesParent = parentUl.closest('.services');
                    const list = parentUl.find('> li');

                    const activeIndex = list.index(parentLi);
                    const servicesMenu = parentLi.find('.services-menu');


                    var clickTween = new TimelineMax();
                    //animate parent move up
                    if (!parentLi.hasClass('active')) { //64
                        clickTween.to(parentUl, 0.25, { y: -((parentLi[0].getBoundingClientRect().height * (activeIndex)) + (activeIndex * 24)), ease: Power2.easeInOut });
                    }
                    else {
                        clickTween.to(servicesMenu, 0.2, { display: 'none', opacity: 0, ease: Power4.easeInOut });
                        clickTween.to(parentUl, 0.25, { y: 0, ease: Power2.easeInOut });
                    }

                    //animate non-selected items
                    for (var i = 0; i < list.length; i++) {
                        if (parentLi.hasClass('active')) { //move to the original coordinates
                            if (i !== index) {
                                clickTween.to(list[i], 0.25, { x: 0, opacity: 1 }, '-=.2');
                            }
                        }
                        else {
                            if (i !== index) { //move to the left
                                clickTween.to(list[i], 0.25, { x: -200, opacity: 0 }, '-=.2');
                            }
                        }
                    }

                    if (parentLi.hasClass('active')) {
                        parentLi.removeClass('active');
                    }
                    else {
                        parentLi.addClass('active');

                        // animate service menu
                        clickTween.to(servicesMenu, 0.5, { opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=0.1');
                    }

                    return false;
                });
        })

    }
}

angular.module('app')
    .directive('animatedServiceBar', animatedServiceBar);
function animatedServiceBar() {
    return {
        restrict: 'E',
        require: '^^animatedServices',
        link: link
    }

    function link(scope, element, attrs, ctrl) {
        const container = angular.element(element);
        const navDots = container.find('> div');
        angular.element(navDots[0]).addClass('active');

        scope.$on('resetServiceNav', function (events, args) {
            angular.element(navDots[parseInt(args.currentSection) - 1]).removeClass('active');
        })

        scope.$on('setServiceNav', function (events, args) {
            angular.element(navDots[parseInt(args.currentSection) - 1]).addClass('active');
        })

        navDots.each(function (key, navDot) {
            angular.element(navDot).on('click', function () {
                if (!angular.element(this).hasClass('active')) {
                    const index = ctrl.slideInfo.currentIndex;
                    const newIndex = key + 1;
                    if (index < newIndex) {
                        $.fn.fullpage.moveSectionDown();
                    }
                    else {
                        $.fn.fullpage.moveSectionUp();
                    }
                }
            })
        })

        scope.$on('hideServiceNav', function (events, args) {
            ctrl.scrollableContents.hideMainNav(); //force hide main nav
            if (args.hide) {
                new TimelineMax()
                    .to(container, 0.25, { opacity: 0, display: 'none', ease: Back.easeIn })
            }
            else {
                new TimelineMax()
                    .to(container, 0.25, { opacity: 0.4, display: 'flex', ease: Back.easeIn })
            }
        })
    }
}